// Narrow-layout filter bottom sheet. Shows the shared account filters + a clear-all action.

import { C } from '../lib/tokens';
import { clearFilters, uiStore } from '../store/uiStore';
import { useUi } from '../store/hooks';
import { AccountFilters } from './accountFilters';

export function BottomSheet() {
  const open = useUi((s) => s.sheetOpen);
  if (!open) return null;
  return (
    <>
      <div onClick={() => uiStore.set({ sheetOpen: false })} style={{ position: 'fixed', inset: 0, background: 'rgba(5,9,17,.55)', zIndex: 44 }} />
      <div
        role="dialog"
        aria-label="Filters"
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 45,
          background: '#0F1726',
          borderTop: '1px solid ' + C.ln,
          borderRadius: '12px 12px 0 0',
          padding: '14px 16px 22px',
          maxHeight: '72vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: 13, fontWeight: 600 }}>Filters</h2>
          <div style={{ flex: 1 }} />
          <button onClick={() => uiStore.set({ sheetOpen: false })} style={{ background: C.bl, border: 'none', borderRadius: 6, color: '#0B1220', fontWeight: 600, fontSize: 12, padding: '6px 14px' }}>
            Done
          </button>
        </div>
        <AccountFilters includeSavedViews={false} />
        <button onClick={clearFilters} style={{ background: 'none', border: '1px solid ' + C.ln, borderRadius: 6, color: C.dm, fontSize: 12, padding: 8 }}>
          Clear all filters
        </button>
      </div>
    </>
  );
}
